<template>
    <v-container fluid>
        <v-card v-if="payresponse" elevation="0">
            <v-card-text>
                <v-card-title>
                    {{ message }}
                </v-card-title>
                <!-- <v-card-subtitle v-if="amount.toString() !== '0'">
                    Amount: &#8369;{{ amount }}
                </v-card-subtitle> -->

                <v-card-subtitle>
                    <v-btn
                        text
                        @click="ReturnToDashboard"
                    >
                        Go to Dashboard
                    </v-btn>
                </v-card-subtitle>
            </v-card-text>

            <v-card-text>
                <v-card-title
                    v-if="eormessage.toString().length > 0"
                >
                    {{ eormessage }}
                </v-card-title>

                <v-progress-linear
                    v-if="eorloaded == false"
                    indeterminate
                    color="red darken-2"
                    height="20"
                    rounded
                    class="mb-5"
                ></v-progress-linear>

                <iframe
                    ref="chartiframe"
                    id="datawrapper-chart-8dfPN" 
                    :src="iframe.src"
                    scrolling="yes"
                    frameborder="0"
                    allowtransparency="true"
                    style="width: 0; min-width: 100% !important;"
                    :height="iframe.height"
                    @load="EORonLoad"
                    class="mt-2"
                >
                    <v-overlay
                        :absolute="true"
                        :value="true"
                    ></v-overlay>
                </iframe>
            </v-card-text>
        </v-card>

        <v-progress-linear
            indeterminate
            color="yellow darken-2"
            height="15"
            rounded
            v-else
        ></v-progress-linear>
    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: 'paymenteor',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - eOR',
    },
    data() {
        return {
            TransactionId: '',
            interval: null,
            details: null,
            payresponse: false,
            message: '',
            eormessage: '',
            eorloaded: false,
            iframe: {
                src: ``,
                height: 400,
                width: '100%',
            },
        }
    },
    methods: {
        EORonLoad() {
            this.eorloaded = true
        },
        ReturnToDashboard() {
            this.$router.push({
                name: 'dashboard'
            }).catch(() => {})
        },
        FetchDetails() {
            axios({
                method: 'post',
                url: `${this.domain}/op_request_details_for_eor`,
                data: {
                    transactionid: this.TransactionId,
                }
            })
                .then(response => {
                    this.payresponse = true

                    if(response.data.response) {
                        const details = this.$jwt.decode(response.data.requestdetails, this.jwtsecret)

                        // console.log(details)

                        if(details.requestdetails.status != 1) {
                            this.message = 'Transaction is still processing... Check this page for updates of the eOR.'
                        } else{
                            this.CancelInterval()

                            if(details.requestdetails.paymentgatewaystatus == 1) {
                                let _link = ''

                                switch(details.requestdetails.division) {
                                    case 'RPTCLEARANCE': case 'CHISS':
                                        _link = `${this.treasuryapi}/MiscEOR.php?data=${details.requestdetails.ornumber.toString()}`

                                        this.iframe.height = 860
                                        break;
                                    case 'RPT':
                                        // _link = `http://35.220.187.169/Treasury/EORPrint.php?data={"collection":["${response.data.ornum.toString()}"]}`
                                        _link = `${this.treasuryapi}/EORPrint.php?data={"collection":["${details.requestdetails.ornumber.toString()}"]}`

                                        this.iframe.height = 560
                                        break;
                                    case 'BPLO':
                                        // console.log(112343425435)

                                        // _link = `http://35.220.187.169/Treasury/EORBPLO.php?data=${response.data.ornum.toString()}`

                                        _link = `${this.treasuryapi}/EORBPLO.php?data=${details.requestdetails.ornumber.toString()}`
                                        this.iframe.height = 860
                                        break;
                                }

                                // message
                                switch(details.requestdetails.division) {
                                    case 'RPTCLEARANCE':
                                        this.eormessage = 'Please claim your Tax Clearance Document by showing this receipt at the Treasury Department of the City Hall'
                                        break;
                                }

                                if(_link.toString().length > 0){
                                    this.iframe.src = _link
                                }
                            } else{
                                this.message = details.requestdetails.altpaynetresponse ? `Transaction Failed. ${details.requestdetails.altpaynetresponse.result.description}` : 'Transaction Failed'
                            }
                        }
                    } else{
                        this.$router.push({
                            name: 'login'
                        }).catch(()=>{})
                    }
                })
                .catch(() => {
                    // console.log(err)
                    this.$router.push({
                        name: 'login'
                    }).catch(()=>{})
                })
        },
        CancelInterval() {
            if(this.interval) {
                clearInterval(this.interval)
            }
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        if(this.$route.params.TransactionId) {
            this.TransactionId = this.$route.params.TransactionId.toString()
        }

        if(this.TransactionId.toString().length == 0) {
            this.$router.push({
                name: 'login'
            }).catch(()=>{})
        }

        this.FetchDetails()

        this.interval = setInterval(() => {
            this.FetchDetails()
        }, 10000)
    },
    beforeDestroy() {
        this.CancelInterval()
    }
}
</script>